export default __webpack_public_path__ + "static/media/arrow-forward-24px.c8ace921.svg";